

const components = {
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 5,
            }
        },
        variants: [
            {
                props: { variant: 'contained' },
                style: {
                    textTransform: 'none',
                    border: 'none',
                    // background: '#9cba5b',
                    color: '#fff',
                    padding: '12px 16px',
                    gap: '10px',
                    // '&:hover': {
                    //     background: '#7EC69D',
                    // },
                    // '&:active': {
                    //     background: '#478A64'
                    // }
                },
            }, {
                props: { variant: 'outlined' },
                style: {
                    textTransform: 'none',
                    border: '2px solid #5EB885',
                    background: 'transparent',
                    color: '#5EB885',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#EFF8F3',
                        border: '2px solid #5EB885',
                    },
                    '&:active': {
                        background: '#DFF1E7',
                        border: '2px solid #5EB885',
                    }
                },
            }, {
                props: { variant: 'text' },
                style: {
                    textTransform: 'none',
                    border: 'none',
                    background: 'transparent',
                    color: '#5EB885',
                    padding: '12px',
                    gap: '8px',
                    '&:hover': {
                        background: '#EFF8F3',
                    },
                    '&:active': {
                        background: '#DFF1E7',
                    }
                },
            },
        ],
    },
    MuiInputBase: {
        styleOverrides: {
            root: {
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 2,
                paddingBottom: 2,
                borderRadius: 20,
                backgroundColor: '#F3F5F7',
            }
        }
    },
    MuiInput: {
        styleOverrides: {
            root: {
                '&:before': {
                    content: 'none',
                },
                '&:after': {
                    content: 'none',
                },
                '&:hover': {
                    content: 'none',
                }
            }
        }
    },
    MuiDataGrid: {
        styleOverrides: {
            root: {
                border: '1px solid #F3F3F1',
                background: '#fff',
                borderRadius: '16px'
            },
            cell: {
                border: 'none'
            },
        }
    }
}

export {components}